import { z } from "zod";
/** Why a profile is reported. */
export const REPORT_REASONS = ["spam", "abuse", "content", "impersonation", "other"];
export const reportReasonSchema = z.enum(REPORT_REASONS);
export const createProfileReportInputSchema = z.object({
    reason: reportReasonSchema,
    comment: z.string().trim().max(500).optional(),
});
/** Why a comment is reported. */
export const COMMENT_REPORT_REASONS = ["spam", "abuse", "spoiler", "offtopic", "other"];
export const commentReportReasonSchema = z.enum(COMMENT_REPORT_REASONS);
export const createCommentReportInputSchema = z.object({
    reason: commentReportReasonSchema,
    note: z.string().trim().max(500).optional(),
});
/** What an admin can do about a reported profile, besides dismissing. */
export const REPORT_MEASURES = ["avatar", "banner", "bio", "wall", "ban"];
export const reportMeasureSchema = z.enum(REPORT_MEASURES);
export const REPORT_STATUSES = ["OPEN", "RESOLVED", "DISMISSED"];
export const adminReportQuerySchema = z.object({
    status: z.enum(["open", "resolved", "dismissed", "all"]).default("open"),
    page: z.coerce.number().int().positive().default(1),
    perPage: z.coerce.number().int().min(1).max(50).default(10),
});
export const adminResolveReportsInputSchema = z
    .object({
    action: z.enum(["resolve", "dismiss"]),
    measures: z.array(reportMeasureSchema).max(REPORT_MEASURES.length).default([]),
    note: z.string().trim().max(500).optional(),
})
    .refine((v) => v.action === "dismiss" || v.measures.length > 0, { message: "Pick at least one measure" });
//# sourceMappingURL=reports.js.map